import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	root: {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: theme.zIndex.drawer + 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "transparent",
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	return (
		<div className={classes.root} aria-hidden="true">
			<CircularProgress color="primary" />
		</div>
	);
};

export default BackdropLoading;
